var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79 4v12a2 2 0 002 2h8a2 2 0 002-2V7.242a2 2 0 00-.603-1.43L16.872 2.57A2 2 0 0015.474 2H10.79a2 2 0 00-2 2v0z",
    stroke: "#BDC1CF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.79 18v2a2 2 0 01-2 2h-8a2 2 0 01-2-2V9a2 2 0 012-2h2",
    stroke: "#BDC1CF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "media/propertyTour/copy-4e5f9d95.svg";
export { SvgCopy as ReactComponent };